<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form"  :rules="rules">
                  <a-form-model-item prop="title" >
                        <span slot="label" ><a-tooltip>{{$t('资讯管理.标题')}}<template slot="title">{{$t('资讯管理.标题')}}</template></a-tooltip> </span>
                        <a-input v-model="form.title" :maxLength="255" :placeholder="$t('通用.输入.请输入')+'标题'" >
                          <locale-field-button
                              slot="suffix"
                              class="ant-input-suffix-button"
                              v-model="form.localeFieldMap['title']"
                              input-type="input"
                              table-name="zb_articles"
                              table-field="title"
                              :field-value="form.title"/>
                        </a-input>
                  </a-form-model-item>
            <a-form-model-item prop="coverImg" >
              <span slot="label" ><a-tooltip>{{$t('资讯管理.封面图')}}<template slot="title">{{$t('资讯管理.封面图')}}</template></a-tooltip> </span>
              <a-upload
                name="coverImg"
                listType="picture-card"
                :multiple="false"
                :show-upload-list="false"
                :preview="handlePreview"
                :before-upload="beforeOssUpload"
                :customRequest="coverImgUpload">
                <img
                  v-if="form.coverImg"
                  :src="form.coverImg"
                  alt="coverImg"
                  style="height: 102px; width: 102px;"/>
                <div v-else>
                  <a-icon :type="loading ? 'loading' : 'plus'"/>
                  <div class="ant-upload-text">{{ $t('通用.按钮.上传') }}</div>
                </div>
              </a-upload>
              <span>推荐尺寸 319*149</span>
<!--              <span>推荐尺寸 {{getBannerSize()}}</span>-->
            </a-form-model-item>
            <a-form-model-item prop="picture" >
                  <span slot="label" ><a-tooltip>{{$t('资讯管理.发布人头像')}}<template slot="title">{{$t('资讯管理.发布人头像')}}</template></a-tooltip> </span>
                    <a-upload
                      name="picture"
                      listType="picture-card"
                      :multiple="false"
                      :show-upload-list="false"
                      :preview="handlePreview"
                      :before-upload="beforeOssUpload"
                      :customRequest="pictureImgUpload">
                      <img
                        v-if="form.picture"
                        :src="form.picture"
                        alt="picture"
                        style="height: 102px; width: 102px;"/>
                      <div v-else>
                        <a-icon :type="loading ? 'loading' : 'plus'"/>
                        <div class="ant-upload-text">{{ $t('通用.按钮.上传') }}</div>
                      </div>
                    </a-upload>
            </a-form-model-item>
                  <a-form-model-item prop="introduction" >
                        <span slot="label" ><a-tooltip>{{$t('资讯管理.发布人')}}<template slot="title">{{$t('资讯管理.发布人')}}</template></a-tooltip> </span>
                        <a-input v-model="form.introduction" :placeholder="$t('通用.输入.请输入')" >
                          <locale-field-button
                            slot="suffix"
                            class="ant-input-suffix-button"
                            v-model="form.localeFieldMap['introduction']"
                            :disabled="!form.introduction"
                            input-type="textarea"
                            table-name="zb_articles"
                            table-field="introduction"
                            :field-value="form.introduction"
                          />
                        </a-input>
                  </a-form-model-item>
                  <a-form-model-item prop="clickNum" >
                        <span slot="label" ><a-tooltip>{{$t('资讯管理.观看量')}}<template slot="title">{{$t('资讯管理.观看量')}}</template></a-tooltip> </span>
                         <a-input-number v-model="form.clickNum" :placeholder="$t('通用.输入.请输入')" allow-clear />
                  </a-form-model-item>
                  <a-form-model-item prop="content" >
                        <span slot="label" ><a-tooltip>{{$t('资讯管理.内容详情富文本')}}<template slot="title">{{$t('资讯管理.内容详情富文本')}}</template></a-tooltip> </span>
                    <div class="editor-i18n-wrapper">
                      <editor v-model="form.content" />
                      <locale-field-button
                        slot="suffix"
                        class="ant-input-suffix-button"
                        v-model="form.localeFieldMap['content']"
                        :disabled="!form.content"
                        input-type="editor"
                        table-name="zb_articles"
                        table-field="content"
                        :field-value="form.content"
                      />
                    </div>
                  </a-form-model-item>
                  <a-form-model-item prop="sort" >
                        <span slot="label" ><a-tooltip>{{$t('资讯管理.排序')}}<template slot="title">{{$t('资讯管理.排序')}}</template></a-tooltip> </span>
                         <a-input-number v-model="form.sort" :placeholder="$t('通用.输入.请输入')" allow-clear />
                  </a-form-model-item>

      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{$t('通用.按钮.保存')}}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{$t('通用.按钮.取消')}}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
  import { getArticles, addArticles, updateArticles } from '@/api/articles/articles'
  import {mapGetters} from 'vuex'
  import CustomDictTag from "@/components/DictCustomTag";
  import {generateFilePath, uploadObject, uploadOss} from "@/api/tool/oss";
  import LocaleFieldButton from "@/components/locale/LocaleFieldButton.vue";

      import Editor from '@/components/Editor'
  import {bannerPosition} from "@/api/advert/banner";

  export default {
    name: 'CreateForm',
  props: {
  },
  components: {
      CustomDictTag,
      LocaleFieldButton,
          Editor
  },
  data () {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      loading: '',
      bannerPositionOptions: [],
      // 表单参数
      form: {
                          id: null,
                          title: null,
                          picture: null,
                          introduction: null,
                          clickNum: null,
                          content: '',
                          sort: null,
                          coverImg: null,
        localeFieldMap:{},
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
                              title: [{ required: true, message: this.$t('资讯管理.标题')+this.$t('通用.文本.不能为空'), trigger: 'blur' }] 
      }
    }
  },
  filters: {
  },
  created () {
    this.getBannerPosition();
  },
  computed: {
  ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.cancel()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
                          id: null,
                          title: null,
                          picture: null,
                          introduction: null,
                          clickNum: null,
                          content: '',
                          sort: null,
                          coverImg: null,
        localeFieldMap:{},
      }

    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('通用.文本.添加')
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getArticles({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('通用.文本.修改')
      })
    },
    // oss 上传开始
    async handlePreview(file) {
      let suffix = file.name.substring(file.name.lastIndexOf('.'));
      if (suffix === '.mp4') {
        this.handleVideoPreview(file);
      } else {
        this.handleImagePreview(file);
      }
    },
    // 上传之前校验
    beforeOssUpload(file) {
      // const isJPG = file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 20
      // if (!isJPG) {
      //     this.$message.error('上传头像图片只能是 JPG 格式!');
      // }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 20MB!')
      }
      return isLt2M
    },
    // 上传覆盖默认的上传行为
    pictureImgUpload(file, index) {
      const _this = this
      // 获取文件对象
      const uploadFile = file.file
      // 文件夹目录
      const prefix = 'banner'
      const url = uploadOss(uploadFile.name, prefix)
      _this.$nextTick(() => {
        uploadObject(url, uploadFile).then(res => {
          _this.$set(_this.form, 'picture', res)
          _this.$message.success(this.$t('通用.文本.上传成功'),)
        })
      })
    },
    // 上传覆盖默认的上传行为
    coverImgUpload(file, index) {
      const _this = this
      // 获取文件对象
      const uploadFile = file.file
      // 文件夹目录
      const prefix = 'banner'
      const url = uploadOss(uploadFile.name, prefix)
      _this.$nextTick(() => {
        uploadObject(url, uploadFile).then(res => {
          _this.$set(_this.form, 'coverImg', res)
          _this.$message.success(this.$t('通用.文本.上传成功'),)
        })
      })
    },

    coverDetailImgUpload(file, index) {
      const _this = this
      // 获取文件对象
      const uploadFile = file.file
      // 文件夹目录
      const prefix = 'banner'
      const url = uploadOss(uploadFile.name, prefix)
      _this.$nextTick(() => {
        uploadObject(url, uploadFile).then(res => {
          _this.$set(_this.form, 'detailImg', res)
          _this.$message.success(this.$t('通用.文本.上传成功'),)
        })
      })
    },
    // oss 上传结束
    getBannerPosition() {
      bannerPosition().then(response => {
        this.bannerPositionOptions = response.data
      })
    },
    getBannerSize() {
      if (this.bannerPositionOptions.length > 0) {
        if (this.form.position) {
          return this.bannerPositionOptions.find(e => e.type === this.form.position).size;
        } else {
          return this.bannerPositionOptions[0].size;
        }
      }

    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = '';
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('通用.文本.修改成功')
            updateArticles(this.form).then(response => {
              if (response.code==='20001') {
                this.$message.success(message,3)
                this.open = false
                this.$emit('ok')
              }
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('通用.文本.修改成功')
            addArticles(this.form).then(response => {
              if (response.code==='20001') {
                this.$message.success(message,3)
                this.open = false
                this.$emit('ok')
              }
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
  }
</script>
<style scoped>
.editor-i18n-wrapper {
  position: relative;
}
/* deep selector to reach into child component root */
.editor-i18n-wrapper /deep/ .ant-input-suffix-button.editor-i18n-btn {
  position: absolute !important;
  bottom: 1px;
  right: 8px !important;
  z-index: 3000;
}
</style>
